<div [appStoryblok]="_editable" [ngClass]="[style]">
  <div class="container-xl">
    <div class="row">
      <div class="col-12" [ngClass]="{ 'text-center': style === 'large' }">
        <h2
          *ngIf="title"
          class="position-relative d-inline-block title text-black"
          [ngClass]="{ 'display-1 text-center': style === 'large' }"
        >
          {{ title }}
          <svg
            *ngIf="style === 'large'"
            class="stroke"
            width="79"
            height="7"
            viewBox="0 0 79 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M77.0909 4.07889C56.2489 2.64882 28.7216 3.62131 2.62819 6.28022C-0.89466 6.55792 -1.40591 3.8714 5.98376 3.17867C30.9719 0.836226 57.185 0.00482993 77.037 1.36739C78.0265 1.45699 78.7558 1.98058 78.6845 3.03369C78.6131 4.0868 78.0801 4.1652 77.0909 4.07889Z"
              fill="#FFAEDF"
            />
          </svg>
        </h2>
      </div>
    </div>

    <div class="row align-items-stretch usp" [ngClass]="style">
      <div class="col-12 col-lg" *ngFor="let blok of content">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </div>
    </div>
  </div>
</div>
